export default class ResultController {
	constructor({ nngGameModel }) {
		this._model = nngGameModel;
	}

	get model() {
		return this._model;
	}

	pageReload() {
		parent.location.reload();
	}
}
